import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function InfoDialogLayout({children, title}: {children: React.ReactNode; title: string}) {
    return (
        <RsnDialog.Window placement='center'>
            <RsnDialog.CenteredHeader>{title}</RsnDialog.CenteredHeader>
            <RsnDialog.Body flex>{children}</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent='secondary'>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
